import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalGoalPlanReview, GlobalGoalPlanReviewCompleteSubmit, GlobalGoalPlanReviewSubmit } from '../../models/global-reviews.model';
import { OidcAuthService } from '@app/core/services/oidc-auth.service';
import { GoalTypeRating } from '../../../goal-types/models/goal-type.model';
import { FormBuilder, Validators } from '@angular/forms';
import { GoalPlanVerbose } from '../../../goal-plans/models/goal-plan.model';
import { ReviewPlansService } from '../../../review-plans/services/review-plans.service';
import { GlobalReviewsService } from '../../services/global-reviews.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { ReviewPlanEmployee } from '../../../review-plans/models/review-plan.model';

@Component({
  selector: 'app-global-goal-plan-reviews',
  templateUrl: './global-goal-plan-reviews.component.html',
  styleUrls: ['./global-goal-plan-reviews.component.scss']
})
export class GlobalGoalPlanReviewsComponent implements OnInit {
  @Input() globalGoalPlanReview: GlobalGoalPlanReview;
  @Input() reviewPlanOwners: ReviewPlanEmployee[] = [];
  @Output() refreshPage: EventEmitter<boolean> = new EventEmitter();

  user$: any;
  showForm: boolean = false;
  error: boolean;
  reviewRatingForm: any;
  goalPlan: GoalPlanVerbose;
  reviewRatingOptions: any[];
  isLoadingRatings: boolean;
  isOwner: boolean = false;

  constructor(
    private fb: FormBuilder,
    private reviewPlansService: ReviewPlansService,
    private oidcAuthService: OidcAuthService,
    private overlayService: OverlayService,
    public translate: TranslateService,
    private snackbarService: SnackbarService,
    private globalReviewsService: GlobalReviewsService
  ) { 
    this.user$ = this.oidcAuthService.userProfile;
  }

  ngOnInit(): void {
    this.getReviewPlanRatings();
    this.isOwner = this.checkIfUserIsOwner();
  }

  checkIfUserIsOwner(): boolean {
    let index = this.reviewPlanOwners?.findIndex(reviewPlanOwner => reviewPlanOwner.id === this.user$.userId)

    if(index === -1) {
      return false;
    }
    else  {
      return true;
    }
  }

  getReviewPlanRatings() {
    this.isLoadingRatings = true;

    this.reviewPlansService.getReviewPlanRatings(this.globalGoalPlanReview.reviewPlan.id, 100, 0, 'SortOrder-asc')
    .subscribe(
      {
        next: (v) => {
          this.reviewRatingOptions = v.data;
        },
        error: (e) => this.error = true,
        complete: () => this.createReviewRatingForm()
      }
    );
  }

  createReviewRatingForm() {
    this.reviewRatingForm = this.fb.group({});
    this.reviewRatingForm.addControl('rating', this.fb.control(this.globalGoalPlanReview?.rating?.id, Validators.required));
    this.reviewRatingForm.addControl('comments', this.fb.control(this.globalGoalPlanReview?.comments, Validators.required));
  }

  save() {
    let globalGoalPlanReviewSubmit: GlobalGoalPlanReviewSubmit = {
      reviewer: this.globalGoalPlanReview?.reviewer?.id,
      goalPlan: this.globalGoalPlanReview?.goalPlan?.id,
      reviewPlan: this.globalGoalPlanReview?.reviewPlan?.id,
      rating: this.reviewRatingForm.get('rating') ? this.reviewRatingForm.get('rating').value : null,
      comments:  this.reviewRatingForm.get('comments') ? this.reviewRatingForm.get('comments').value : null,
    }
    
    this.overlayService.show();
    
    this.globalReviewsService.updateGlobalGoalPlanReview(globalGoalPlanReviewSubmit)
    .subscribe(
      {
        next: (v) => {
          this.snackbarService.openSnackBar(this.translate.instant('SavedSuccessfully'), 'clear', 'success');
        },
        error: (e) => this.error = true,
        complete: () => this.overlayService.hide()
      }
    );
  }

  complete() {
    let globalGoalPlanReviewCompleteSubmit: GlobalGoalPlanReviewCompleteSubmit = {
      reviewer: this.globalGoalPlanReview?.reviewer?.id,
      goalPlan: this.globalGoalPlanReview?.goalPlan?.id,
      reviewPlan: this.globalGoalPlanReview?.reviewPlan?.id,
    }
    
    this.overlayService.show();

    this.globalReviewsService.completeGlobalGoalPlanReview(globalGoalPlanReviewCompleteSubmit)
    .subscribe(
      {
        next: (v) => {
          this.snackbarService.openSnackBar(this.translate.instant('SavedSuccessfully'), 'clear', 'success');
        },
        error: (e) => this.error = true,
        complete: () => { 
          this.overlayService.hide(); 
          this.globalGoalPlanReview.status = { id: 'Complete', name: 'Complete' };
        }
      }
    );
  }

  revert() {
    let globalGoalPlanReviewCompleteSubmit: GlobalGoalPlanReviewCompleteSubmit = {
      reviewer: this.globalGoalPlanReview?.reviewer?.id,
      goalPlan: this.globalGoalPlanReview?.goalPlan?.id,
      reviewPlan: this.globalGoalPlanReview?.reviewPlan?.id,
    }
    
    this.overlayService.show();

    this.globalReviewsService.revertGlobalGoalPlanReview(globalGoalPlanReviewCompleteSubmit)
    .subscribe(
      {
        next: (v) => {
          this.snackbarService.openSnackBar(this.translate.instant('SavedSuccessfully'), 'clear', 'success');
        },
        error: (e) => this.error = true,
        complete: () => { 
          this.overlayService.hide(); 
          this.globalGoalPlanReview.status = { id: 'Pending', name: 'Pending' };
        }
      }
    );
  }

}
